// extracted by mini-css-extract-plugin
export var attachment = "_q1-a";
export var emailContainer = "_q1-4";
export var emailContentPaddedContainer = "_q1-b";
export var emailHeader = "_q1-6";
export var emailIframe = "_q1-3";
export var emailInfoIcon = "_q1-9";
export var emailShortenedSummary = "_q1-e";
export var infoDropdown = "_q1-0";
export var infoRowBoundedContent = "_q1-d";
export var internal = "_q1-5";
export var merchant = "_q1-8";
export var messageInputContainer = "_q1-h";
export var normal = "_q1-7";
export var replyCard = "_q1-f";
export var subtleButton = "_q1-1";
export var subtleButtonIconContainer = "_q1-2";
export var toggleViewRepliesButton = "_q1-c";
export var wrappingText = "_q1-g";